var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", { staticClass: "role-span" }, [_vm._v("门店信息")])]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.form, size: "small", "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门店名称" } },
                _vm._l(_vm.storeName, function (item, index) {
                  return _c(
                    "el-tag",
                    { key: index, staticStyle: { "margin-right": "2px" } },
                    [_vm._v(_vm._s(item))]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店店长" } },
                [
                  _vm._l(_vm.storeManagerNickName, function (item, index) {
                    return _c(
                      "el-tag",
                      { key: index, staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "storeinto:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("门店店长")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店导购" } },
                [
                  _vm._l(_vm.storeSellerNickName, function (item, index) {
                    return _c(
                      "el-tag",
                      { key: index, staticStyle: { "margin-right": "2px" } },
                      [_vm._v(_vm._s(item))]
                    )
                  }),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "storeinto:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("门店导购")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设计师" } },
                [
                  _vm._l(_vm.designerList, function (item, index) {
                    return _c(
                      "el-tag",
                      { key: index, staticStyle: { "margin-right": "4px" } },
                      [
                        _vm._v(
                          _vm._s(item.user ? item.user.nickName : "未命名")
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "storeinto:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("设计师")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设计中心派单员" } },
                [
                  _vm._l(_vm.dispatchDesignerList, function (item, index) {
                    return _c(
                      "el-tag",
                      { key: index, staticStyle: { "margin-right": "4px" } },
                      [
                        _vm._v(
                          _vm._s(item.user ? item.user.nickName : "未命名")
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.$parent.checkPer(["admin", "storeinto:edit"])
                    ? _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.onUserSelect("设计中心派单员")
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onUserSelectClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }